import { NoPlaceZoneBooking } from "../../../features/Booking-Form/typings/booking-service-administration.types";
import { BookingScheduleDto } from "../../../features/Booking-Form/typings/booking.types";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { SCHEDULE_QUERY_STALE_TIME_MS } from "./schedule-query-cache.constants";

type Params = {
  bookingScheduleDto: BookingScheduleDto;
  hasNoPlaceZoneLicense: boolean;
};

export function useRemoteFetchNoPlaceZoneBookingSchedule(params: Params) {
  const { bookingScheduleDto, hasNoPlaceZoneLicense } = params;
  const { userIds, startDate, endDate } = bookingScheduleDto;

  return useRemoteQuery<NoPlaceZoneBooking[]>({
    queryKey: ["NoPlaceZoneBookingSchedule", bookingScheduleDto],
    url: "/booking-schedule/noplacezone",
    params: { userIds, startDate, endDate },
    enabled: !!startDate && !!endDate && hasNoPlaceZoneLicense,
    staleTime: SCHEDULE_QUERY_STALE_TIME_MS
  });
}
